<template>
<div id="App">
  <Capture/>

  <!-- <Mobile v-if="$root.$agent.smartphone || $root.$agent.tablet != null || $root.$agent.mobile != null "/> -->
  <!-- <template v-if="!$root.$agent.smartphone && $root.$agent.tablet == null && $root.$agent.mobile == null"> -->

  <Mobile v-if="$root.$agent.smartphone || $root.isSafariOnPad == true || $root.isSafari == true && $root.isSafariOnPad == true || $root.isSafari == true && this.$root.isIpad == false"/>
  <template v-else>
    <Navigation v-if="loaded" />
    <Sound v-if="loaded" />
   <!--  <Narration v-if="loaded
    && !$root.$agent.smartphone 
    && $root.$agent.tablet == null 
    && $root.$agent.mobile == null" /> -->
    <Narration v-if="loaded" />
    <World />
    <!-- <div class="Timeline" v-if="!$root.isMomentaServer">
      <router-link
        :to="{ name: 'museum.' + lang, params: { slug: moment }}"
        class="Timeline__moment"
        :key="moment"
        :class="[ {'is-active': moment == $route.params.slug }]"
        v-for="(moment, index) in scenario">
        {{ moment }}<br><span>{{ index }}</span>
      </router-link>
    </div> -->
    <transition
      @enter="enter" @after-enter="afterEnter"
      @leave="leave" @after-leave="afterLeave"
      @before-enter="beforeEnter"
      :css="false" appear :mode="mode">
      <router-view ref="page" v-if="loaded && clicked" />
    </transition>
    <Loader v-if="!loaded || !clicked"/>
    <EndControl />
    <BackMessage ref="backmessage" /> 
  </template>
</div>
</template>

<script>

import Loader from '@/components/loader/Loader'
import Navigation from '@/components/navigation/Navigation'
import Transition from '@/core/mixins/Transition'
import World from '@/components/world/World'
import Sound from '@/components/sound/Sound'
import Narration from '@/components/narration/Narration'
import BackMessage from '@/components/back-message/BackMessage'
import Mobile from '@/components/mobile/Mobile'
import Capture from '@/components/defis/components/Capture'
import EndControl from '@/components/controls/EndControl'

export default {
  name: 'App',
  mixins: [ Transition ],
  components: { Loader, Navigation, World, Sound, BackMessage, Mobile, Narration, Capture, EndControl },
  created() {

    console.log(this.clicked +' --');
    
    if(this.$root.$agent.smartphone || this.$root.isSafariOnPad == true || this.$root.isSafari == true && this.$root.isSafariOnPad == true || this.$root.isSafari == true && this.$root.isIpad == false) return

    const segments = [
			'oeuvres',
			'oeuvres_archives',
      'options/aventure',
      'options/en-classe',
      'options/equipe',
      'options/glossaire',
    ]

		_.each(segments, segment => {
      this.$store.commit(
        'loader/PROMISE_PUSH',
        this.$http.get(segment, { params: {
          per_page: 500,
          hide_empty: 0,
          orderby: 'menu_order',
          order: 'asc'
        }}).then( res => {
          if(res.data.acf) {

            this.$store.commit('app/SET_DATA', { type: segment, data: res.data.acf })

          } else {

            const clean = _.map(res.data, r => ({ id: r.id, ...r.acf }))
            // this.$store.commit('app/SET_DATA', { type: segment, data: clean })

            // Temp .
            
            if(segment == 'oeuvres') {
              let arr = []
              _.each(clean, (o)=>{

                // if(o.year == 2050) {
                  // console.log(o.name);
                  arr.push(o)
                // }
              })
              this.$store.commit('app/SET_DATA', { type: segment, data: arr })
            }

            // else
              // this.$store.commit('app/SET_DATA', { type: segment, data: clean })

          }
				})
      )
    })
  },
  computed: {
    loaded() {
      return this.$store.getters['loader/loaded']
    },
    clicked() {
      return this.$store.getters['loader/clicked']
    },
  },

  methods: {
    sniff() {
      window.alert('sniff')
    },
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/fonts/Fonts'
@import '~@/commons/stylus/Reset'
@import '~@/commons/stylus/Global'
@import '~@/commons/stylus/Page'
@import '~@/commons/stylus/Vlazy'
@import '~@/commons/stylus/Btn'
@import '~@/commons/stylus/Close'
@import '~@/commons/stylus/Tooltip'

#App
  position absolute
  width 100vw
  height 100vh
  background black
  overflow hidden

.Timeline
  position fixed
  bottom 1px
  width 100vw
  background rgba(black, .5)
  white-space nowrap
  overflow-x auto
  z-index 9999
  transform translateY(68px)
  transition transform 1s
  &::-webkit-scrollbar
    width 0px
    background transparent
  &:hover
    transform translateY(10px)

  &__moment
    display inline-block
    padding 0 10px
    font-size 12px
    position relative
    text-align center
    color white
    transition background .5s
    background rgba(white, 0)
    span
      font-size 8px
    &.is-active
      background rgba(white, .2)
</style>



// WEBPACK FOOTER //
// src/App.vue